export default __webpack_public_path__ + "static/media/PNSLogo.3c392c0a.svg";